var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.08 15.5C18.1833 14.1389 17.7165 12.5397 17.74 10.91V10.73C17.7373 9.80303 17.505 8.89116 17.0637 8.07593C16.6224 7.2607 15.986 6.56752 15.2114 6.05836C14.4368 5.5492 13.548 5.23993 12.6247 5.1582C11.7013 5.07647 10.772 5.22483 9.92002 5.59001C8.92106 6.00155 8.06916 6.70432 7.47522 7.60682C6.88128 8.50932 6.57283 9.56974 6.59002 10.65V10.71C6.59796 12.456 6.04012 14.1576 5.00002 15.56L4.34002 16.5C4.0716 16.8651 3.92784 17.3069 3.93002 17.76C3.93002 18.3223 4.15337 18.8615 4.55095 19.2591C4.94853 19.6567 5.48776 19.88 6.05002 19.88H18C18.2784 19.88 18.5541 19.8252 18.8113 19.7186C19.0685 19.6121 19.3022 19.4559 19.4991 19.2591C19.6959 19.0622 19.8521 18.8285 19.9586 18.5713C20.0652 18.3141 20.12 18.0384 20.12 17.76V17.7C20.1243 17.2728 19.9987 16.8543 19.76 16.5L19.08 15.5Z",
    fill: "#424C9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.09 20.8199C10.157 21.284 10.389 21.7085 10.7435 22.0154C11.0979 22.3224 11.5511 22.4914 12.02 22.4914C12.4889 22.4914 12.9421 22.3224 13.2966 22.0154C13.6511 21.7085 13.883 21.284 13.95 20.8199H10.09Z",
    fill: "#424C9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.76 5.18V3.25C12.76 3.05109 12.681 2.86032 12.5403 2.71967C12.3997 2.57902 12.2089 2.5 12.01 2.5C11.8111 2.5 11.6203 2.57902 11.4797 2.71967C11.339 2.86032 11.26 3.05109 11.26 3.25V5.15C11.2541 5.17296 11.2541 5.19704 11.26 5.22C11.7564 5.14468 12.2603 5.13124 12.76 5.18Z",
    fill: "#424C9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.36d435f3c0ae642097c14a728a7575ca.svg";
export { ForwardRef as ReactComponent };